import Avatar from '@/components/Admin/reusableComponents/Avatar';
import { Fragment } from 'react';
import Skeleton from 'react-loading-skeleton';
import { connect } from 'react-redux';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const MileageTooltip = ({ active, payload }) => {
    if (active && payload?.length) {
        const { user, name, miles } = payload[0].payload;
        return (
            <div style={{ background: 'white', padding: 10, border: '1px solid #ccc' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar item={user} />
                    <span style={{ marginLeft: 8 }}>{name}</span>
                </div>
                <div>Miles: {miles.toFixed(2)}</div>
            </div>
        );
    }
    return null;
};

const SkeletonLoader = () => (
    <Fragment>
        {[...Array(5)].map((_, i) => (
            <div key={i}>
                <Skeleton />
            </div>
        ))}
    </Fragment>
);
const MileageBarChart = ({ teamDashboardVisit = {} }) => {
    const chartData = Object.values(teamDashboardVisit?.groupedMileageByEmployee || {}).map((item) => ({
        name: item.employee?.user?.name || 'Unknown',
        miles: item.miles,
        user: item.employee?.user,
    }));

    if (teamDashboardVisit?.loading) {
        return <SkeletonLoader />;
    }

    if (!chartData.length) {
        return <div className="text-center">No Record Found</div>;
    }
    return (
        <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
                <BarChart data={chartData} layout="vertical" margin={{ top: 10, right: 30, bottom: 10 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" />
                    <YAxis dataKey="name" type="category" width={200} fontSize={12} />
                    <Tooltip content={<MileageTooltip />} />
                    <Legend
                        verticalAlign="bottom"
                        formatter={() => <span style={{ color: '#50aeb0' }}>Mileage ( unit: miles )</span>}
                    />
                    <Bar dataKey="miles" fill="#50aeb0" barSize={20} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

const mapStateToProps = (state) => ({
    teamDashboardVisit: state.dashboard?.teamVisit || {},
    teams: state.teams.teams,
});

export default connect(mapStateToProps, {})(MileageBarChart);
